module.exports = __webpack_public_path__ + "7b7728d6c1a0375e696c54a47c7017aa.jpg";